<template>
  <b-container class="px-0">
    <div v-for="review in reviews" :key="review.uuid">
      <educational-item-review :review="review"></educational-item-review>
    </div>
    <!-- Conditional button for loading more -->
    <div class="d-flex justify-content-center" v-if="page < totalPages">
      <b-btn variant="primary" size="lg" @click="loadMore()"
        >Load more<b-spinner v-if="loading" small></b-spinner
      ></b-btn>
    </div>
  </b-container>
</template>

<script>
import EducationalItemReview from '@/components/educational_resources/EducationalItemReview'

export default {
  components: { EducationalItemReview },
  name: 'EducationalItemReviewList',
  props: {
    uuid: String,
    isAdmin: Boolean,
  },
  data() {
    return {
      loading: false,
      page: 1,
      totalPages: 0,
      reviews: [],
    }
  },
  mounted() {
    this.loadReviews()
  },
  methods: {
    loadReviews() {
      this.loading = true

      this.$http
        .get(`/resources/${this.uuid}/reviews?page=${this.page}`)
        .then((res) => {
          this.reviews = res.data.data
          this.totalPages = res.data.meta.last_page
        })
        .finally(() => {
          this.loading = false
        })
    },

    loadMore() {
      this.page += 1
      this.loadReviews()
    },
  },
}
</script>


